export const isFunction = (v: any) => typeof v === 'function';